module.exports = __webpack_public_path__ + "assets/img/packet.d0e6e0d4.png";